import { render } from "./UserDetalle.vue?vue&type=template&id=04c904a2&scoped=true"
import script from "./UserDetalle.vue?vue&type=script&lang=js"
export * from "./UserDetalle.vue?vue&type=script&lang=js"

import "./UserDetalle.vue?vue&type=style&index=0&id=04c904a2&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c904a2"]])

export default __exports__